import { Component, EventEmitter, Input, Output, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, BaseFormSubCadastro, BaseFormSubCadastroService, MessageService } from '../../../../core';
import { Cidade, CidadeCrudHttpService } from '../../../cidade';

import { PessoaEndereco } from '../pessoa-endereco';

@Component({
    selector: 'sgt-pessoa-endereco-form',
    templateUrl: './pessoa-endereco-form.component.html'
})
export class PessoaEnderecoFormComponent implements BaseFormSubCadastro<PessoaEndereco>, OnInit {
    entity: PessoaEndereco;
    entityIndex: number;
    editMode: boolean;
    @ViewChild('form') form: NgForm;

    @Input() entities: PessoaEndereco[];
    @Input() isOpen: boolean;
    @Output() save = new EventEmitter<PessoaEndereco>();
    @Output() cancel = new EventEmitter<any>();

    cidades: Cidade[] = [];

    constructor(private baseFormSubCadastroService: BaseFormSubCadastroService,
                private messageService: MessageService,
                private cidadeCrudHttpService: CidadeCrudHttpService) { }

    ngOnInit() {
        this.searchCidades();
    }

    /** Pesquisa todas as cidades */
    private searchCidades() {
        this.cidadeCrudHttpService.search()
            .subscribe(
                entities => this.cidades = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as cidades', error)
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new PessoaEndereco();
    }

    edit(index: number) {
        this.entityIndex = index;
        this.editMode = true;
        this.entity = this.baseFormSubCadastroService.prepareEdit(this.entityIndex, this.entities);
    }


    onSave() {
        this.baseFormSubCadastroService.save(this.entity,
                                             this.entities,
                                             this.form,
                                             this.editMode,
                                             this.entityIndex,
                                             'Para salvar o endereço é preciso informar corretamente todos os campos destacados em vermelho')
            .then(() => this.save.emit(this.entity))
            .catch(() => {});
    }

    onCancel() {
        this.cancel.emit();
    }
}
